import React, { Component } from "react";
import { connect } from "react-redux";
import learningCenterTheme from "../../theme/learningCenterTheme";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import withTheme from "@mui/styles/withTheme";
import { compose } from "redux";
import { Route } from "react-router-dom";
import {
  errorPage,
  syncAccount,
  termsAndConditions,
  loggedOut,
  unauthorized
} from "../../routes/Routes";
import ErrorPage from "../../views/MiscPages/ErrorPage";
import SyncAccount from "../../views/MiscPages/SyncAccount";
import LoggedOut from "../../views/MiscPages/LoggedOut";
import TermsAndConditions from "../../views/MiscPages/TermsAndConditions";

class MiscPagesContainer extends Component {
  render() {
    const { theme } = this.props;
    return (
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={learningCenterTheme(theme)}>
          <CssBaseline />
          <Route path={errorPage} component={ErrorPage} />
          <Route path={syncAccount} component={SyncAccount} />
          <Route path={termsAndConditions} component={TermsAndConditions} />
          <Route path={loggedOut} component={LoggedOut} />
          <Route path={unauthorized} component={ErrorPage} />
        </ThemeProvider>
      </StyledEngineProvider>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default compose(
  withTheme,
  connect(mapStateToProps, mapDispatchToProps)
)(MiscPagesContainer);
